import { useState } from 'react';
import { Box, Container, Stack, Tab, Tabs, Typography } from '@mui/material';
import ExecutiveSummary2025View from '../views/ExecutiveSummary2025View';
import MarginStatusView from '../views/MarginStatusView';
import DecisionView from '../views/DecisionView';
import IndustrialCostsView from '../views/IndustrialCostsView';
import YieldView from '../views/YieldView';
import QualityVendibleView from '../views/QualityVendibleView';

type ViewKey = 'summary' | 'costs' | 'yield' | 'quality' | 'margin' | 'decision';

export default function IndustrialRiskPage() {
  const [view, setView] = useState<ViewKey>('summary');

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#0f172a',
        color: '#f8fafc',
        py: { xs: 4, md: 6 },
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={2.5}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 900, letterSpacing: -0.8 }}>
              Industrial Risk Engine
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8, mt: 0.5 }}>
              Visión ejecutiva del negocio industrial: compras, rentabilidad observada y apoyo a decisiones bajo incertidumbre real.
            </Typography>
          </Box>

          <Tabs
            value={view}
            onChange={(_, v) => setView(v)}
            textColor="inherit"
            indicatorColor="secondary"
            sx={{
              '& .MuiTab-root': { textTransform: 'none', fontWeight: 700 },
              '& .MuiTabs-indicator': { bgcolor: 'rgba(255,255,255,0.7)' },
            }}
          >
            <Tab value="summary" label="Resumen 2025" />
            <Tab value="costs" label="Costes industriales" />
            <Tab value="yield" label="Rendimiento" />
            <Tab value="quality" label="Calidad vendible" />
            <Tab value="margin" label="Estado del margen" />
            <Tab value="decision" label="Decisión" />
          </Tabs>

          {view === 'summary' && <ExecutiveSummary2025View />}
          {view === 'costs' && <IndustrialCostsView />}
          {view === 'yield' && <YieldView />}
          {view === 'quality' && <QualityVendibleView />}
          {view === 'margin' && <MarginStatusView />}
          {view === 'decision' && <DecisionView />}
        </Stack>
      </Container>
    </Box>
  );
}